import {
  PenTool,
  RectangleGoggles,
  Boxes,
  Users,
  Megaphone,
  Check,
  CircleDot,
  Brain,
  Hand,
  TriangleAlert,
  Crosshair,
  Puzzle,
  Building2,
  TabletSmartphone,
  Lightbulb,
} from "lucide-react";
import { Reveal } from "../lib/motion";
import { useLang } from "../lib/i18n";
import { Kicker, SectionTitle, Watermark, PortalDoorCard } from "./Shared";

const CARD_META = [
  {
    icon: PenTool,
    idealIcons: [Users, Megaphone, Check, CircleDot],
  },
  {
    icon: RectangleGoggles,
    idealIcons: [Hand, TriangleAlert, Crosshair, Brain],
  },
  {
    icon: Boxes,
    idealIcons: [Puzzle, Building2, TabletSmartphone, Lightbulb],
  },
];

/**
 * Bloc 3 — ce que le studio crée.
 * Trois savoir-faire. Habillage carte = style « portes » (PortalDoorCard).
 */
export const Studio = () => {
  const { t } = useLang();
  const s = t.studio;

  return (
    <section
      id="studio"
      data-testid="studio-section"
      className="relative pt-36 md:pt-48 pb-24 md:pb-32 overflow-hidden bg-section"
    >
      <Watermark n="02" />

      <div className="relative z-10 max-w-site mx-auto px-6 md:px-12">
        <Reveal className="mb-14 md:mb-20 max-w-3xl">
          <Kicker>{s.kicker}</Kicker>
          <SectionTitle lead={s.title[0]} accent={s.title[1]} stacked />
          <p className="mt-6 text-warm font-light leading-relaxed">{s.desc}</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7 items-stretch">
          {s.items.map((item, i) => {
            const meta = CARD_META[i];
            const idealItems = (item.ideal || []).map((label, j) => ({
              label,
              icon: meta.idealIcons[j],
            }));

            return (
              <Reveal key={item.title} delay={i * 0.08} className="h-full flex flex-col">
                <PortalDoorCard
                  className="flex-1"
                  icon={meta.icon}
                  verb={item.verb}
                  title={item.title}
                  hook={item.hook}
                  description={item.desc}
                  idealLabel={s.idealLabel}
                  idealItems={idealItems}
                />
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
